export default __webpack_public_path__ + "static/media/no-image.410fde4f.svg";